document.addEventListener('DOMContentLoaded', function () {
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        const cartCount = document.querySelector('.cart-count');
        if(data.item_count > 0){
          const cartCountMain = document.querySelector('#cart-count-bubble-text');
          document.querySelector(".cart-count-bubble").style.display = "block";
          cartCountMain.textContent = data.item_count;
        }
        cartCount.textContent = data.item_count;
      })
      .catch(error => {
        console.error('Error fetching cart data:', error);
      });
  }

  function showPopup(message) {
    const popup = document.createElement('div');
    popup.className = 'cart-popup';
    
    const closeButton = document.createElement('button');
    closeButton.className = 'close-popup';
    closeButton.innerHTML = '&times;'; // X symbol
    closeButton.addEventListener('click', function () {
      popup.remove();
    });
  
    popup.textContent = message;
    popup.appendChild(closeButton);
    document.body.appendChild(popup);
  
    setTimeout(() => {
      popup.classList.add('show');
    }, 10);
  
    setTimeout(() => {
      if (document.body.contains(popup)) {
        popup.classList.remove('show');
        setTimeout(() => {
          popup.remove();
        }, 500);
      }
    }, 5000);
  }  

  updateCartCount();

  document.querySelectorAll('.add-to-cart-btn').forEach(button => {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      const form = this.closest('form');
      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        if (data.status && data.status !== 200) {
          throw new Error(data.description || 'Error adding to cart');
        }

        const quantityAdded = formData.get('quantity') || 1;
        showPopup(`${quantityAdded} product(s) added to the cart`);

        updateCartCount();
      })
      .catch(error => {
        console.error('Error:', error);
        alert('There was an error adding the item to the cart.');
      });
    });
  });

  // Quantity increment and decrement functionality
  document.querySelectorAll('.quantity-wrapper').forEach(wrapper => {
    const quantityInput = wrapper.querySelector('.quantity-input');
    const decrementBtn = wrapper.querySelector('.decrement-btn');
    const incrementBtn = wrapper.querySelector('.increment-btn');

    decrementBtn.addEventListener('click', function () {
      let currentValue = parseInt(quantityInput.value, 10);
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
    });

    incrementBtn.addEventListener('click', function () {
      let currentValue = parseInt(quantityInput.value, 10);
      quantityInput.value = currentValue + 1;
    });

    quantityInput.addEventListener('input', function () {
      if (quantityInput.value === '' || parseInt(quantityInput.value, 10) < 1) {
        quantityInput.value = 1;
      }
    });
  });

  const searchBar = document.querySelector('.search-bar');
  const searchIcon = document.querySelector('.search-icon');
  const clearSearchIcon = document.querySelector('.clear-search');

  function updateIcons() {
    if (searchBar.value.trim() === '') {
      searchIcon.style.display = 'block';
      clearSearchIcon.style.display = 'none';
    } else {
      searchIcon.style.display = 'none';
      clearSearchIcon.style.display = 'block';
    }
  }

  function filterProducts(searchTerm) {
    const rows = document.querySelectorAll('.product-order');
    rows.forEach(row => {
      const productName = row.querySelector('.product-name').textContent.toLowerCase();
      if (productName.includes(searchTerm)) {
        row.style.display = '';
      } else {
        row.style.display = 'none';
      }
    });
  }

  searchBar.addEventListener('input', function () {
    const searchTerm = this.value.toLowerCase();
    filterProducts(searchTerm);
    updateIcons();
  });

  clearSearchIcon.addEventListener('click', function () {
    searchBar.value = '';
    updateIcons();
    filterProducts('');
  });

  updateIcons();
});